var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"title"},[_vm._v("《"+_vm._s(_vm.title)+"》 ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"text","size":"mini"},on:{"click":_vm.handleSelect}},[_vm._v("选择")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12c21b73","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectMovie/index.vue
// module id = null
// module chunks = 